import type { Config } from '#src/config/config.ts';
import { Flavors } from '@packages/primitives/flavor';

export const config: Config = {
  flavor: Flavors.PROD,
  sentry: {
    enabled: true,
    environment: Flavors.PROD,
    dsn: 'https://422262f94198a9073d57d5b6cf8eb72e@o4508249614909440.ingest.de.sentry.io/4509638431539280',
    debug: false,
    tunnel: '/spi/tunnel',
  },
  posthog: {
    enabled: true,
    debug: false,
    uiHost: 'https://us.i.posthog.com',
    apiHost: '/spi/hoggy',
    key: 'phc_dkjmPubOXoYpT0cDKVzVK68oKtk7yTLF9OsKooHikHN',
  },
};
